module.exports = __webpack_public_path__ + "static/media/icon.5563f1e2.png";